import { logWrapper } from '../../utils';

export default {
  uploadRevisionService: [
    'runtimeConstant',
    '$sce',
    'systemConfigService',
    'EXT_ICONS',
    'additionalFieldService',
    'validationService',
    function (
      runtimeConstant,
      $sce,
      systemConfigService,
      EXT_ICONS,
      AdditionalField,
      validationService
    ) {
      function uploadRevision(item) {
        var fileName = item.file.name;

        if (fileName.endsWith('p7s')) {
          var extP7s = fileName.substr(fileName.lastIndexOf('.'));
          var originalName = fileName.substr(0, fileName.lastIndexOf('.p7s'));
          var extOriginal = originalName.substr(
            originalName.lastIndexOf('.') + 1
          );
          this.Extension = extOriginal + extP7s;
          this.IsSigned = true;
        } else {
          this.Extension = fileName.substr(fileName.lastIndexOf('.') + 1);
        }

        this.Size = item.file.size;
        this.RevisionAdditionalFields = [];
        var checkin = item.currentDocument;

        if (checkin) {
          this.Title = checkin.title;
          this.Id = checkin.id;
          this.IdAuthor = checkin.idAuthor;
          this.IdCompany = checkin.idCompany;
          this.IdDocumentType = checkin.idDocumentType;
          this.IdFolder = checkin.idFolder;
          this.Description = checkin.description;
          this.Keywords = checkin.keywords ? checkin.keywords.split(';') : null;

          for (var i = 0; i < checkin.revisionAdditionalFields.length; i++) {
            var c = checkin.revisionAdditionalFields[i];
            this.RevisionAdditionalFields.push(new AdditionalField(c));
          }

          this.RevisionAdditionalFields = this.RevisionAdditionalFields;

          if (
            checkin.documentType !== null &&
            checkin.documentType.RevisionInterval !== null
          ) {
            var docInterval = checkin.documentType.RevisionInterval;
            var nextDate = new Date(
              Date.now() + docInterval * 24 * 60 * 60 * 1000
            );

            nextDate.setHours(0);
            nextDate.setMinutes(0);
            nextDate.setSeconds(0);
            nextDate.setMilliseconds(0);

            this.NextRevisionDate = nextDate;
            this.NotificationDays = checkin.documentType.NotificationDays;

            if (checkin.documentType.CanOverrideInterval) {
              this.NotificationDays = checkin.notificationDays;
            }
          }

          this._documentType = checkin.documentType;
          this._folder = checkin.folder;
        } else {
          this.Title = fileName.substr(0, fileName.lastIndexOf('.'));
          this.Id = null;
          this.IdAuthor = null;
          this.IdCompany = null;
          this.IdDocumentType = null;
          this.IdFolder = null;
          this.RevisionDate = new Date(Date.now());
          this.Description = '';
          this.Keywords = '';
          this._documentType = null;
          this._folder = null;
        }
      }

      function emptyTitle() {
        return (
          this.Title === undefined ||
          this.Title === null ||
          this.Title.trim() === ''
        );
      }

      function emptyFolder() {
        return (
          this.IdFolder === undefined ||
          this.IdFolder === null ||
          this.IdFolder === 0
        );
      }

      function emptyDocType() {
        return (
          this.IdDocumentType === undefined ||
          this.IdDocumentType === null ||
          this.IdDocumentType === 0
        );
      }

      function isDescriptionRequired() {
        var config = systemConfigService.getConfig();
        return (
          !this.Description && config && config.isDescriptionRevisionRequired
        );
      }

      function canSave() {
        if (
          this.emptyTitle() ||
          this.emptyFolder() ||
          this.emptyDocType() ||
          this.isDescriptionRequired()
        ) {
          return false;
        }
        return true;
      }

      function canSaveAddFields() {
        var fields =
          this.RevisionAdditionalFields.filter(function (a) {
            var can = !a.required || (a.required && a.value) ? true : false;

            switch (a.fieldType) {
              case 1:
                break;
              case 2: {
                if (can && !isNaN(a.value)) return false;
                return true;
              }
              case 4:
                if (!(can || isNaN(a.value))) {
                  return a;
                }
                break;
              case 3:
                if (!can) {
                  return a;
                }
                if (a.validationType === 1 && a.value) {
                  //cpf
                  if (!validationService.validateCPF(a.value)) {
                    return a;
                  }
                }
                if (a.validationType === 2 && a.value) {
                  //cnpj
                  if (!validationService.validateCNPJ(a.value)) {
                    return a;
                  }
                }
                break;
              default:
                if (!can) {
                  return a;
                }
                break;
            }
          }).length === 0;
        return fields;
      }

      function folder(value) {
        if (arguments.length > 0) {
          this._folder = value;
          this.IdFolder = value.Id;
        } else {
          return this._folder;
        }
      }

      function documentType(value) {
        if (arguments.length > 0) {
          this._documentType = value;
          this.IdDocumentType = value.Id;
        } else {
          return this._documentType;
        }
      }

      function workflow(value) {
        if (arguments.length > 0) {
          this._workflow = value;
          this.IdWorkflow = value !== null ? value.IdWorkflow : null;
        } else {
          return this._workflow;
        }
      }

      function formatedSize() {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var len = this.Size;
        var order = 0;
        while (len >= 1024 && order + 1 < sizes.length) {
          order++;
          len = len / 1024;
        }

        return len.toFixed(2).toString() + ' ' + sizes[order];
      }

      function getIcon() {
        var ext = this.Extension;
        var isP7s = ext.toLowerCase().endsWith('p7s');
        if (isP7s) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png" ></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px"></img>';
        }

        if (isP7s) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function getLargeIcon() {
        var ext = this.Extension;
        var isP7s = ext.toLowerCase().endsWith('p7s');
        if (isP7s) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/large/default.png" width="32px"></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          image =
            '<img src="/assets/images/file_extensions/large/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/large/default.png\';" width="32px"></img>';
        }
        if (isP7s) {
          image +=
            '<img class="large_signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function run() {
        try {
          uploadRevision.prototype = {
            emptyTitle: logWrapper(
              emptyTitle,
              runtimeConstant.isDebugServicesInternals
            ),
            emptyFolder: logWrapper(
              emptyFolder,
              runtimeConstant.isDebugServicesInternals
            ),
            emptyDocType: logWrapper(
              emptyDocType,
              runtimeConstant.isDebugServicesInternals
            ),
            isDescriptionRequired: logWrapper(
              isDescriptionRequired,
              runtimeConstant.isDebugServicesInternals
            ),
            canSave: logWrapper(
              canSave,
              runtimeConstant.isDebugServicesInternals
            ),
            canSaveAddFields: logWrapper(
              canSaveAddFields,
              runtimeConstant.isDebugServicesInternals
            ),
            folder: logWrapper(
              folder,
              runtimeConstant.isDebugServicesInternals
            ),
            documentType: logWrapper(
              documentType,
              runtimeConstant.isDebugServicesInternals
            ),
            workflow: logWrapper(
              workflow,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedSize: logWrapper(
              formatedSize,
              runtimeConstant.isDebugServicesInternals
            ),
            getIcon: logWrapper(
              getIcon,
              runtimeConstant.isDebugServicesInternals
            ),
            getLargeIcon: logWrapper(
              getLargeIcon,
              runtimeConstant.isDebugServicesInternals
            ),
          };

          return uploadRevision;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
